export const normalizeParametersOptions = (options) =>
    (options || [])
        .map((option) => {
            if (!option) return null;
            if (typeof option === "string") {
                return { value: option, label: option };
            }
            const value = option.value ?? option.libelleParametre ?? "";
            const label = option.label ?? option.libelleParametre ?? value;
            if (!value) return null;
            return { value, label };
        })
        .filter(Boolean)
        .sort((a, b) => a.label.localeCompare(b.label, "fr", { sensitivity: "base" }));



export const uniqueBy = (arr, key) => {
    const seen = new Set();
    return arr.filter(item => {
        const value = item[key];
        if (seen.has(value)) return false;
        seen.add(value);
        return true;
    });
};

export const highlightMatch = (text, q) => {
    if (!q || !text) return text;
    const regex = new RegExp(`(${q.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&")})`, "i");
    const parts = text.toString().split(regex);
    return parts.map((part, index) =>
        regex.test(part) ? (
            <mark key={index} style={{ background: "rgba(74, 144, 226, 0.2)", color: "#242166", padding: "2px 4px", borderRadius: "3px" }}>
                {part}
            </mark>
        ) : (
            <span key={index}>{part}</span>
        )
    );
};

// ── Garanties de sinistre : normalisation d'affichage ────────────────────────────────
// Toutes les variantes de la Responsabilité Civile ("RC", "RC de base", "Responsabilité
// civile", code contrat RC/ICDB) désignent la MÊME garantie et s'affichent « RC ».
export const estGarantieRC = (nom) => {
    const t = (nom || "").toString().trim().toUpperCase();
    return t.startsWith("RC") || t.startsWith("ICDB") || t.includes("RESPONSABILIT");
};

// Libellé d'affichage normalisé d'une garantie de sinistre.
export const libelleGarantie = (nom) => (estGarantieRC(nom) ? "RC" : (nom || "").toString().trim());

// Normalise + déduplique une liste de noms de garanties (variantes RC repliées sur « RC »).
export const normaliserGaranties = (noms) => {
    const seen = new Set(); const out = [];
    (noms || []).forEach((n) => {
        const v = libelleGarantie(n);
        if (v && !seen.has(v)) { seen.add(v); out.push(v); }
    });
    return out;
};
